import urlUtils from './urlutils';

const processNextStep = (routes, activeStepIndex, steps, nextStepLinks, activeMainStepIndex) => {
  const nextStepIndex = activeStepIndex + 1;
  let nextMainStepIndex = activeMainStepIndex + 1;

  if (nextStepLinks && nextStepLinks.length) {
    const nextStep = routes[nextStepLinks[0].rel];
    const newSteps = Object.assign([], steps);

    if (nextStep.endHere) {
      const deleteCount = newSteps.length - activeStepIndex;
      newSteps.splice(nextStepIndex, deleteCount, nextStep);
    } else if (nextStep.subStepOf) {
      newSteps.splice(nextStepIndex, 0, nextStep);
      nextMainStepIndex = activeMainStepIndex;
    } else {
      newSteps[nextStepIndex] = nextStep;
    }

    return {
      nextStepIndex,
      nextMainStepIndex,
      nextSteps: newSteps,
      nextStep,
    };
  }

  return {
    nextStepIndex,
    nextMainStepIndex: nextStepIndex,
    nextSteps: steps,
    nextStep: steps[nextStepIndex],
  };
};

const getRegistrationModeAndPortal = (hostname) => {
  const host = hostname || window.location.hostname;

  const registrationMode =
    host.indexOf('register-admin') > -1 ? 'rm' : urlUtils.getQuerystring('mode');
  let portal = host.indexOf('shiftpayments') > -1 ? 'SP' : 'CP';

  portal = !registrationMode ? portal : 'GC';

  return { registrationMode, portal };
};

const workflowUtils = {
  processNextStep,
  getRegistrationModeAndPortal,
};

export default workflowUtils;
